<template>
  <div>
    <v-layout row wrap px-10 pt-8 mb-12>
      <v-flex xs12>
        
        <v-layout row wrap>
          <v-flex xs12>
            {{ $t('1') }}
          </v-flex>
        </v-layout>
        <v-layout row wrap mt-8>
          <v-flex xs12>
            <v-textarea :label="$t('2')" auto-grow rows="1" v-model="mainSkillsStr" dense outlined hide-details/>
          </v-flex>
        </v-layout>
        <v-layout row wrap v-for="(category, index) in categories" :key="index">
          <v-flex xs12 my-4>
            <v-divider/>
          </v-flex>
          <v-flex xs4>
            <v-text-field :label="$t('3')" v-model="category.category" dense outlined hide-details/>
          </v-flex>
          <v-spacer/>
          <v-flex xs7>
            <v-textarea :label="$t('4')" auto-grow rows="1" v-model="category.skillsStr" dense outlined hide-details/>
          </v-flex>
          <v-flex ml-1 pt-1>
            <v-btn fab @click="removeCategory(index)" x-small elevation="0">
              <v-icon small>mdi-delete</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-layout row wrap mt-6>
          <v-flex xs12>
            <v-btn small class="primary" @click="addCategory">
              <v-icon class="mr-2" small>mdi-plus</v-icon>
              <span>{{ $t('5') }}</span>
            </v-btn>
          </v-flex>
        </v-layout>

      </v-flex>
    </v-layout>
  </div>
</template>


<script>

export default {
  components: {

  },
  props: {
    profile: Object,

  },
  data:() => ({
    mainSkillsStr: '',
    categories: []
  }),
  mounted() {
    this.mainSkillsStr = this.profile.skills.technicalSkillsV2.mainSkills.join(', ')
    this.categories = this.profile.skills.technicalSkillsV2.categories.map(x => {
      return {
        category: x.category,
        skillsStr: x.skills.join(', ')
      }
    })
  },
  computed: {

  },
  methods: {
    addCategory() {
      this.categories.push({
        category: '',
        skillsStr: ''
      })
    },
    removeCategory(index) {
      this.categories.splice(index, 1);
    }
  },
  watch: {
   mainSkillsStr: {
    handler() {
      this.profile.skills.technicalSkillsV2.mainSkills = this.mainSkillsStr.split(/[,;\n]+/).map(x => x.trim().replace(/[.\s]+$/g, '')).filter(Boolean)
    }
   },
   categories: {
    handler() {
      this.profile.skills.technicalSkillsV2.categories = this.categories.map(x => {
        return {
          category: x.category,
          skills: x.skillsStr.split(/[,;\n]+/).map(x => x.trim().replace(/[.\s]+$/g, '')).filter(Boolean)
        }
      }).filter(x => x.category || x.skills.length > 0)
    },
    deep: true
   }
  }
};
</script>


<i18n>
{
  "fr": {
    "1": "Séparez les compétences par une virgule, un point-virgule, ou un retour à la ligne.",
    "2": "Compétences principales",
    "3": "Nom de la catégorie",
    "4": "Liste de compétences",
    "5": "Ajouter une catégorie"
  },
  "en": {
    "1": "Separate skills with a comma, semicolon, or a newline.",
    "2": "Main skills",
    "3": "Category name",
    "4": "Skills list",
    "5": "Add a category"
  }
}
</i18n>